import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_MODELS } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const getPropertyModels = async () => await axiosAuth.get(`${PROPERTY_MODELS}`);

const useGetPropertyModels = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-models"],
    queryFn: () => getPropertyModels(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyModels;
